import $ from 'jquery';
if(navigator.userAgent.toLowerCase().indexOf('android') > -1){
    $('body').addClass('android');
}


// WEBPACK FOOTER //
// src/lib/hack.js